module.exports = __webpack_public_path__ + "pc-static/img/4.06d505c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4.jpg
// module id = CtaL
// module chunks = 1